/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { isAuthenticated, Whoami } from './core/authentication'
import './scss/style.scss';
import GlobalStyle from './global-styles'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import _ from 'lodash';
// Pages
import Login from './views/logins';
// generate invoice
import InvoiceGenerate from './views/accounts/invoices/generate';

import { HubSocketHelper } from './core/socket/driverLiveLocationSocket';
import { GetResultObject, PutRequest, UPDATE_DRIVER_ONLINE_STATUS } from './utils/API';
import {useDispatch, useSelector} from "react-redux";
import actions from './core/redux/action';
import './core/notification/firebase';
import Hub2Notification from './core/notification/app_notification';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

class App extends Component {

  //dispatch = null;
  constructor(props) {
    super(props)
    this.state = {
      isAuthenticated: true
    }
  }

  // Toast
  driverOffline(name) { return toast.warning(`Driver ${name} is go offline`);}
  driverOnline(name){ return toast.success(`Driver ${name} is go online`); }

  async componentDidMount() {
    let key = await isAuthenticated()
    this.setState({ isAuthenticated: key })

    // get common
    // if(key === 'true'){
    //   this.props.getProvinces()
    //   this.props.getSender()
    // }
    if(!window.location.href.includes('/link/generate/invoice') && key){
      this.initSocket()
    }
  }


  initSocket() {
    const ws = new HubSocketHelper("HUB2B")
    ws.listenEvent("ONLINE", (socket) => {
      // ---
    })
    ws.listenEvent("OFFLINE", (socket) => {
      
      // dispatch(actions.on)
      //notify()
      PutRequest(UPDATE_DRIVER_ONLINE_STATUS, {driverId: socket.room, online: false}, {}).then(result => {
        GetResultObject(result, 'data', 200, data => { // data is driver
          // const dispatch = useDispatch()
          // dispatch(actions.updateDriverLocation(data))
          // this.driverOffline(_.get(data, 'name'))
        })
      })
    })

  }

  render() {
    const { isAuthenticated } = this.state
    console.log(window.location.href)
    // console.log("render", isAuthenticated)
    if(window.location.href.includes('/link/generate/invoice')){
      return(
      <>
        <InvoiceGenerate />
      </>
      )
    }
    return (
      <>
        {(isAuthenticated === 'true')  ? (
          <HashRouter>
            <React.Suspense fallback={loading}>
              <Switch>
                <Route exact path="/register" name="Register Page" render={props => <Register {...props} />} />
                <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
                <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
                <Route exact path="/link/generate/invoice" name="Page 500" render={props => <InvoiceGenerate {...props} />} />
                <Route path="/" name="Home" render={props => <TheLayout {...props} />} />
              </Switch>
            </React.Suspense>
          </HashRouter>
        ) : (<Login />)}

        <Hub2Notification />

        <ToastContainer />
        <GlobalStyle/>
      </>
    )
  }

}

// export default connect(state => state, actions)(App)
export default App;
